<script>
  // @ts-nocheck

  import 'flowbite'
  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query'
  import { width } from 'utils/device'
  import { Router, Route } from 'svelte5-router'
  import LazyComponent from 'app/routing/LazyComponent.svelte'
  import Navbar from 'app/shell/Navbar/Navbar.svelte'
  import TilesInfo from 'app/shell/Navbar/TilesInfo.svelte'
  import Auth from 'app/shell/Auth/Auth.svelte'
  import { dashboardRoutes } from 'stores/dashboardNavbar'
  import { navHeight } from 'stores/navigation'
  import { ROUTES } from 'app/routing/routes'
  import { FEATURES_FLAGS } from 'utils/constants'
  import Toast from 'shared/feedback/Toast/Toast.svelte'
  import Pendo from 'app/shell/Pendo.svelte'
  import { getFlagValue } from 'services/launchdarkly/client'
  import { featureFlagStore } from 'stores/featureFlag'
  import { toastStore } from '../stores/toast'
  import { onMount } from 'svelte'
  import { cleanupInactivityListeners, showSessionTimeoutModal } from '../stores/sessionTimeout'
  import auth from 'services/auth/authService'
  import SessionTimeoutModal from 'app/shell/SessionTimeoutModal/SessionTimeoutModal.svelte'
  import { initializeSessionTimeoutModal } from '../stores/sessionTimeout'

  const { DASHBOARD_ROUTES } = ROUTES
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  })
  dashboardRoutes.set({ DASHBOARD_ROUTES })

  const loadDashboard = () => import('app/routing/homeDashboard/Dashboard.svelte')
  const loadPhysician = () => import('app/routing/phy/Physician.svelte')
  const loadAdvancePracticeProvider = () => import('app/routing/app/AdvancePracticeProvider.svelte')
  const loadAdmin = () => import('app/routing/admin/Admin.svelte')
  const loadNotFound = () => import('app/routing/NotFound.svelte')

  function handleRouteChange() {
    toastStore.subscribe(toasts => {
      toasts.forEach(toast => {
        if (toast.autoClose) {
          toastStore.destroyToast(toast.id)
        }
      })
    })()
  }

  onMount(() => {
    initializeSessionTimeoutModal()

    window.addEventListener('popstate', handleRouteChange)

    const originalPushState = history.pushState
    history.pushState = function (...args) {
      originalPushState.apply(this, args)
      handleRouteChange()
    }

    getFlagValue(FEATURES_FLAGS.ENABLE_ADMIN_PAGE, newVal => {
      featureFlagStore.setFlag('enableAdminPanel', newVal)
    }).then(flagValue => {
      featureFlagStore.setFlag('enableAdminPanel', flagValue)
    })

    return () => {
      window.removeEventListener('popstate', handleRouteChange)
      history.pushState = originalPushState
      cleanupInactivityListeners()
    }
  })
</script>

<Auth>
  <QueryClientProvider client={queryClient}>
    <TilesInfo />
    <Pendo />
    <Router>
      <Navbar />
      <div style="min-height: calc(100vh - {$navHeight}px); margin-top: {$navHeight}px;">
        <div data-cy="main-content">
          <Route path="/">
            {#snippet children(params)}
              <LazyComponent loader={loadDashboard} {params} />
            {/snippet}
          </Route>
          <Route path="phy/*">
            {#snippet children(params)}
              <LazyComponent loader={loadPhysician} {params} />
            {/snippet}
          </Route>
          <Route path="app/*">
            {#snippet children(params)}
              <LazyComponent loader={loadAdvancePracticeProvider} {params} />
            {/snippet}
          </Route>
          <Route path="admin/*">
            {#snippet children(params)}
              <LazyComponent loader={loadAdmin} {params} />
            {/snippet}
          </Route>
          <Route path="/*">
            {#snippet children(params)}
              <LazyComponent loader={loadNotFound} {params} />
            {/snippet}
          </Route>
        </div>
      </div>
    </Router>
  </QueryClientProvider>
</Auth>
<svelte:window bind:innerWidth={$width} />
<Toast dataCy="toast-message" />
<SessionTimeoutModal
  bind:visible={$showSessionTimeoutModal}
  countdownSeconds={120}
  onstay={async () => {
    showSessionTimeoutModal.set(false)
    initializeSessionTimeoutModal()
  }}
  onlogoff={() => {
    auth.logout()
    showSessionTimeoutModal.set(false)
  }}
/>
